import createLucideIcon from '../createLucideIcon';

const Clock2 = createLucideIcon('Clock2', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['polyline', { points: '12 6 12 12 16 10', key: '1g230d' }],
]);

export default Clock2;
